import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Headers, Response, RequestOptions } from "@angular/http"

//service
import { UserService } from "../service/user.service";

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html'
})

export class ForgotPasswordComponent {
  currentUser: any;
  email: string;
  public showError: boolean;
  public showSuccess: boolean;
  public errorMessage: string;
  public forgotPasswordTemplate: boolean;
  public resendActivationEmailTemplate: boolean;
  queryStringEmail: string;

  constructor(
    private router: Router,
    private http: Http,
    private userService: UserService,
    private activateRoute: ActivatedRoute) {

    this.currentUser = {
      email: ""
    }
  }

  ngOnInit() {
    this.queryStringEmail = this.activateRoute.snapshot.queryParams['email'];
    
    if (this.queryStringEmail == undefined) {
      this.forgotPasswordTemplate = true;
      this.resendActivationEmailTemplate = false;
    }
    else {
      this.forgotPasswordTemplate = false;
      this.resendActivationEmailTemplate = true;
      this.currentUser.email = this.queryStringEmail;
    }
  }

  forgotPassword() {
    this.showError = false;
    this.errorMessage = "";

    this.email = this.currentUser.email;

    if (this.currentUser.email == "") {
      this.showError = true;
      this.errorMessage = "Enter email";
      return;
    }

    return this.userService.forgotPassword(this.email)
      .subscribe((result) => {
        this.errorMessage = result.json().message || "A new mail with reset password has been sent";
        this.showError = false;
        this.showSuccess = true;
      },
        err => {
          this.errorMessage = err.json().message || "Invalid Email";
          this.showError = true;
        })
  }
}


// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.ts